import { render, staticRenderFns } from "./ReviewResponse.vue?vue&type=template&id=60667894&scoped=true"
import script from "./ReviewResponse.vue?vue&type=script&lang=js"
export * from "./ReviewResponse.vue?vue&type=script&lang=js"
import style0 from "./ReviewResponse.vue?vue&type=style&index=0&id=60667894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60667894",
  null
  
)

export default component.exports